const config = {
  AUTH_ENDPOINT: process.env.REACT_APP_AUTH_ENDPOINT
};

export default config;
